import { useSyncExternalStore } from 'react';
import { subscribe, getVersionState } from '@/lib/version-monitor';

// `useSyncExternalStore` requires snapshot equality across calls when
// nothing changed — return the primitive directly so React's referential
// check holds without us caching a wrapper object in version-monitor.
function snapshot(): boolean {
  return getVersionState().updateAvailable;
}

/**
 * Returns true once a frontend build different from the one this tab booted
 * with is confirmed to be actually served (not merely advertised by the
 * CloudFront header mid-deploy). See `src/lib/version-monitor.ts`.
 */
export function useUpdateAvailable(): boolean {
  return useSyncExternalStore(subscribe, snapshot, snapshot);
}
